import React from 'react'
import PropTypes from 'prop-types'
import Label from './Label'
import InputWrap from './InputWrap'
import DatePicker, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import useInput from '../../hooks/useInput'
import da from 'date-fns/locale/da'
import { isAfter, isSameDay } from 'date-fns'

registerLocale('da', da)

export default function DateInput ({
  name,
  context,
  label,
  required = false,
  size,
  time,
  placeholder,
  minDate,
  allowedDays,
  defaultValue = null
}) {

  const { getValue, setValue } = useInput(context)

  const handleOnChange = function (date) {
    setValue(name, date.toISOString().slice(0, 19).replace('T', ' '))
  }

  const handleSelected = () => {
    if (!minDate) {
      return Date.parse(getValue(name))
    }

    if (isAfter(Date.parse(getValue(name)), minDate) || isSameDay(Date.parse(getValue(name)), minDate)) {
      return Date.parse(getValue(name))
    } else {
      return null
    }
  }

  const filterDate = (date) => {
    if (!allowedDays) return true

    const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
    const dayOfWeek = dayNames[date.getDay()]

    return allowedDays[dayOfWeek] === true
  }

  React.useEffect(() => {
    if (defaultValue !== null && !getValue(name)) {
      setValue(name, defaultValue)
    }
  }, [])

  return (
    <InputWrap size={size}>
      <Label required={required}>{label}</Label>
      <DatePicker
        selected={handleSelected()}
        onChange={handleOnChange}
        showTimeSelect={time}
        placeholderText={placeholder}
        locale={'da'}
        timeCaption={'Tid'}
        minDate={minDate}
        filterDate={filterDate}
        dateFormat={time ? 'dd/MM yyyy HH:mm' : 'dd/MM yyyy'}
      />
    </InputWrap>
  )
}

DateInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  size: PropTypes.oneOf(['half', 'third']),
  allowedDays: PropTypes.object
}